module.exports = __webpack_public_path__ + "static/scale-model-of-zilker-zephyr-miniature-train-in-austin-texas-39beb17b8738712d14590d02b5411fd9.png";